import SitesSessionStorageService from './sitesSessionStorageService.js';
/**
 *
 * BrowserDetection object is immediately executed when the page loads.
 * This Object is used to detect the browser and version the user is using.
 *
 * @namespace SearchSessionStorageService
 */
class SearchSessionStorageService {
    constructor() {
    }

    getRecentSearchData() {
        //check local storage for our search data
        if(SitesSessionStorageService.getItem("globalRecentSearches")) {
            return SitesSessionStorageService.getItem("globalRecentSearches");
        }
        return [];
    }

    setRecentSearchData(item) {
        let recentSearches = JSON.parse(SitesSessionStorageService.getItem("globalRecentSearches"));

        if(recentSearches) {
            //check for the same search value in array
            let tempArr = [];
            tempArr[0] = item;
            for(let i = 0; i < recentSearches.length; i++) {
                if(recentSearches[i].itemName != item.itemName) {
                    tempArr.push(recentSearches[i]);
                }
            }
            if(tempArr.length > 6) {
                tempArr = tempArr.slice(0, 6);
            }
            // var globalRecentSearches = tempArr;
            SitesSessionStorageService.writeItem("globalRecentSearches", JSON.stringify(tempArr));
        } else {
            let globalRecentSearches = [item];
            SitesSessionStorageService.writeItem("globalRecentSearches", JSON.stringify(globalRecentSearches));
        }
    }

    deleteRecentSearchData() {
        SitesSessionStorageService.removeItem("globalRecentSearches");
    }
}

export default new SearchSessionStorageService();
